module.exports = __webpack_public_path__ + "static/media/edulyst-banner.cf60348c.png";